import { AxiosInstance } from 'axios';
import { createVideoUrlBuilder } from './create-video-url-builder';

export class VideoSourceGenerator {
  constructor(private api: AxiosInstance) {}

  private applyHttpsFix(url: string) {
    return url.replace('http://', 'https://');
  }

  private resolveParams(params: MpdParams) {
    return {
      cameraId: params.cameraId,
      fromTime: params.fromTime,
      timeshift: params.timeshift,
      toTime: params.toTime,
      isLive: params.isLive,
      alignSegment: params.alignSegment,
      arbitraryFromTime: params.arbitraryFromTime,
      arbitraryToTime: params.arbitraryToTime,
    };
  }

  private getLiveFromTime(timeshift: number = 0) {
    return new Date(Date.now() - timeshift * 1000).toISOString();
  }

  public getPresignUrl(params: MpdParams) {
    const {
      cameraId,
      isLive,
      fromTime,
      toTime,
      arbitraryFromTime,
      arbitraryToTime,
    } = this.resolveParams(params);
    const videoUrl = createVideoUrlBuilder(
      this.api.defaults.baseURL
    ).setCameraId(cameraId);

    if (isLive) {
      videoUrl.setFromTime(this.getLiveFromTime());
    } else if (fromTime && toTime) {
      videoUrl.setFromTime(fromTime);
      videoUrl.setToTime(toTime);
      videoUrl.setAlignSegment(true);
    } else if (arbitraryFromTime && arbitraryToTime) {
      videoUrl.setFromTime(new Date(arbitraryFromTime).toISOString());
      videoUrl.setToTime(new Date(arbitraryToTime).toISOString());
    } else {
      videoUrl.setFromTime(this.getLiveFromTime());
    }

    return videoUrl.build();
  }

  public async fetchPresignedMpd(params: MpdParams) {
    const presignUrl = this.getPresignUrl(params);
    const response = await this.api.get<{
      url: string;
      is_live: boolean;
      valid_until_seconds: number;
    }>(presignUrl);

    response.data.url = this.applyHttpsFix(response.data.url);

    return response.data;
  }
}

type MpdParams = {
  cameraId: string | null;
  fromTime?: string;
  timeshift?: number;
  toTime?: string;
  isLive?: boolean;
  alignSegment?: boolean;
  arbitraryFromTime?: number | null;
  arbitraryToTime?: number | null;
};
